export default __webpack_public_path__ + "static/media/responsive.889908ff.png";